"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loading: false,
      id: null,
      list: []
    };
  },
  created: function created() {
    this.id = this.$route.query.id;
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      var data = {
        accountId: this.id
      };
      (0, _user.getAccountDetail)(data).then(function (res) {
        _this.loading = false;
        if (res.data.errno == 0) {
          _this.list = res.data.data;
        }
        console.log(res, 'resres');
      }).catch(function () {});
    }
  },
  components: {}
};